import {
  Component, OnInit, Input, HostListener, ChangeDetectorRef, Output, EventEmitter,
  forwardRef, ViewChild, ElementRef, HostBinding
} from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
export const RADIO_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioButtonComponent),
  multi: true
};
@Component({
    selector: 'app-radio-button',
    template: `<div class="form-check mb-0">
  <input  #rd class="form-check-input" [checked]="checked" [value]="value" type="radio">
  <label [ngStyle]="{'font-size.px':size}" class="form-check-label" for="courier">{{labelName}}</label>
</div>`,
    providers: [RADIO_VALUE_ACCESSOR],
    standalone: false
})
export class RadioButtonComponent implements OnInit, ControlValueAccessor {

  @Input() value: any;
  @Input() checked = false;
  @Input() labelName: any;
  @Input() size: any;
  @Input() formControl: UntypedFormControl;
  @Input() disabled = false;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @ViewChild('rd', { static: true }) radioButton: ElementRef;
  @Input() @HostBinding('tabindex') tabindex = -1;


  onChange: any = (fn: any) => { };
  onTouched: any = () => { };
  constructor(private cd: ChangeDetectorRef) { }
  @HostListener('click')
  onClick() {
    if (this.disabled) {
      return;
    }
    this.checked = true;
    this.radioButton.nativeElement.focus();
    if (this.value) {
      const value = this.checked ? this.value : null;
      this.onChange(value);
      this.change.emit(value);

    } else {
      this.change.emit(this.checked);
      this.onChange(this.checked);
    }
  }
  @HostListener('blur')
  onBlur() {
    this.radioButton.nativeElement.blur();
    this.onTouched();
  }
  ngOnInit() {
  }
  writeValue(obj: any): void {
    this.checked = (obj === this.value);

    if (this.radioButton.nativeElement) {
      this.radioButton.nativeElement.checked = this.checked;
    }
    this.cd.markForCheck();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
